/**
 * Body accessories: scifi
 */
import * as THREE from 'three';

export function buildAcc_steampunk_boiler(lib, accGroup, torsoW, torsoH, torsoD, _opts, _handY, _sideX) {
  // LÒ HƠI MINI ĐỒNG THAU PHUN KHÓI (Steampunk Boiler)
  const brassMat = new THREE.MeshStandardMaterial({ color: '#b45309', metalness: 0.85, roughness: 0.3 });
  const pipeMat = new THREE.MeshStandardMaterial({ color: '#78350f', metalness: 0.9, roughness: 0.2 });
  const gaugeMat = new THREE.MeshStandardMaterial({ color: '#fef08a', roughness: 0.4 });
  lib.disposables.push(brassMat, pipeMat, gaugeMat);

  // Thùng lò hơi hình hộp bo góc sau lưng
  const tankGeo = new THREE.BoxGeometry(torsoW * 0.95, torsoH * 0.85, torsoD * 0.9);
  const tank = new THREE.Mesh(tankGeo, brassMat);
  tank.position.set(0, torsoH * 0.5, -torsoD * 0.85);
  tank.castShadow = true;
  accGroup.add(tank);

  // 2 Ống khói vươn cao
  [-1, 1].forEach((side) => {
    const pipeGeo = new THREE.CylinderGeometry(0.04, 0.05, 0.28, 12);
    const pipe = new THREE.Mesh(pipeGeo, pipeMat);
    pipe.position.set(side * torsoW * 0.28, torsoH * 0.95, -torsoD * 0.85);
    accGroup.add(pipe);
    lib.disposables.push(pipeGeo);
  });

  // Đồng hồ đo áp suất trước ngực
  const gaugeGeo = new THREE.CylinderGeometry(0.06, 0.06, 0.02, 16);
  gaugeGeo.rotateX(Math.PI / 2);
  const gauge = new THREE.Mesh(gaugeGeo, gaugeMat);
  gauge.position.set(0, torsoH * 0.65, torsoD * 0.52);
  accGroup.add(gauge);

  lib.disposables.push(tankGeo, gaugeGeo);
}

export function buildAcc_acid_tanks(lib, accGroup, torsoW, torsoH, torsoD, _opts, _handY, _sideX) {
  // CẶP BÌNH HÓA CHẤT AXIT DẠ QUANG (Acid Tanks)
  const tankMat = new THREE.MeshStandardMaterial({ color: '#14532d', roughness: 0.6 });
  const acidGlowMat = new THREE.MeshBasicMaterial({ color: '#4ade80' });
  const harnessMat = new THREE.MeshStandardMaterial({ color: '#1c1917', roughness: 0.8 });
  lib.disposables.push(tankMat, acidGlowMat, harnessMat);

  [-1, 1].forEach((side) => {
    const cylGeo = new THREE.CylinderGeometry(0.09, 0.09, torsoH * 0.85, 12);
    const cyl = new THREE.Mesh(cylGeo, tankMat);
    cyl.position.set(side * torsoW * 0.32, torsoH * 0.5, -torsoD * 0.88);
    accGroup.add(cyl);

    // Vạch thủy ngân dung dịch axit phát quang
    const coreGeo = new THREE.BoxGeometry(0.04, torsoH * 0.65, 0.02);
    const core = new THREE.Mesh(coreGeo, acidGlowMat);
    core.position.set(side * torsoW * 0.32, torsoH * 0.5, -torsoD * 0.88 - 0.08);
    accGroup.add(core);

    lib.disposables.push(cylGeo, coreGeo);
  });

  // Dây đai chéo trước ngực
  const sGeo = new THREE.BoxGeometry(torsoW * 0.85, 0.05, 0.025);
  const s = new THREE.Mesh(sGeo, harnessMat);
  s.position.set(0, torsoH * 0.55, torsoD * 0.52);
  s.rotation.z = 0.5;
  accGroup.add(s);
  lib.disposables.push(sGeo);
}

export function buildAcc_tesla_coil(lib, accGroup, torsoW, torsoH, torsoD, _opts, _handY, _sideX) {
  // CUỘN DÂY TESLA TÍCH ĐIỆN VŨ TRỤ (Cosmic Tesla Coil)
  const coilMat = new THREE.MeshStandardMaterial({ color: '#b45309', metalness: 0.9, roughness: 0.2 });
  const ringMat = new THREE.MeshBasicMaterial({ color: '#38bdf8' });
  lib.disposables.push(coilMat, ringMat);

  // Trụ lõi cuộn sau lưng
  const postGeo = new THREE.CylinderGeometry(0.07, 0.07, torsoH * 0.95, 12);
  const post = new THREE.Mesh(postGeo, coilMat);
  post.position.set(0, torsoH * 0.55, -torsoD * 0.85);
  accGroup.add(post);

  // Vòng hào quang điện từ tròn trên đỉnh
  const torGeo = new THREE.TorusGeometry(0.18, 0.03, 8, 20);
  const tor = new THREE.Mesh(torGeo, ringMat);
  tor.position.set(0, torsoH * 1.05, -torsoD * 0.85);
  tor.rotation.x = Math.PI / 2;
  accGroup.add(tor);

  lib.disposables.push(postGeo, torGeo);
}

export function buildAcc_chrono_gears(lib, accGroup, torsoW, torsoH, torsoD, _opts, _handY, _sideX) {
  // CỤM BÁNH RĂNG THỜI GIAN LỒNG GHÉP (Chrono Gears)
  const gearMat = new THREE.MeshStandardMaterial({ color: '#d97706', metalness: 0.85, roughness: 0.25 });
  lib.disposables.push(gearMat);

  // Bánh răng lớn chính giữa lưng
  const g1Geo = new THREE.CylinderGeometry(0.24, 0.24, 0.04, 16);
  g1Geo.rotateX(Math.PI / 2);
  const g1 = new THREE.Mesh(g1Geo, gearMat);
  g1.position.set(0, torsoH * 0.6, -torsoD * 0.62);
  accGroup.add(g1);

  // Bánh răng nhỏ bên phải
  const g2Geo = new THREE.CylinderGeometry(0.14, 0.14, 0.04, 12);
  g2Geo.rotateX(Math.PI / 2);
  const g2 = new THREE.Mesh(g2Geo, gearMat);
  g2.position.set(torsoW * 0.32, torsoH * 0.35, -torsoD * 0.6);
  accGroup.add(g2);

  lib.disposables.push(g1Geo, g2Geo);
}

export function buildAcc_accretion_ring(lib, accGroup, torsoW, torsoH, _torsoD, _opts, _handY, _sideX) {
  // ĐĨA BỒI TỤ HẮC ĐỘNG / VÀNH ĐAI SAO (Accretion Disk Ring)
  const ringMat = new THREE.MeshBasicMaterial({ color: '#c084fc', side: THREE.DoubleSide });
  lib.disposables.push(ringMat);

  const rGeo = new THREE.RingGeometry(0.35, 0.52, 24);
  rGeo.rotateX(Math.PI / 2.3);
  const rMesh = new THREE.Mesh(rGeo, ringMat);
  rMesh.position.set(0, torsoH * 0.45, 0);
  accGroup.add(rMesh);

  lib.disposables.push(rGeo);
}

export function buildAcc_radiation_core(lib, accGroup, torsoW, torsoH, torsoD, _opts, _handY, _sideX) {
  // LÕI PHẢN ỨNG HẠT NHÂN / HỒ QUANG (Reactor Core)
  const glowMat = new THREE.MeshBasicMaterial({ color: '#22d3ee' });
  const frameMat = new THREE.MeshStandardMaterial({ color: '#0f172a', metalness: 0.9, roughness: 0.1 });
  lib.disposables.push(glowMat, frameMat);

  // Lõi phát sáng trước ngực
  const coreGeo = new THREE.CylinderGeometry(0.08, 0.08, 0.03, 16);
  coreGeo.rotateX(Math.PI / 2);
  const core = new THREE.Mesh(coreGeo, glowMat);
  core.position.set(0, torsoH * 0.6, torsoD * 0.52);
  accGroup.add(core);

  // Khung titan bảo vệ
  const fGeo = new THREE.BoxGeometry(0.18, 0.18, 0.02);
  const f = new THREE.Mesh(fGeo, frameMat);
  f.position.set(0, torsoH * 0.6, torsoD * 0.51);
  accGroup.add(f);

  lib.disposables.push(coreGeo, fGeo);
}

export function buildAcc_jetpack(lib, accGroup, torsoW, torsoH, torsoD, _opts, _handY, _sideX) {
  // BALO PHẢN LỰC VŨ TRỤ (Cosmic Jetpack)
  const packMat = new THREE.MeshStandardMaterial({ color: '#334155', metalness: 0.8, roughness: 0.3 });
  const thrusterMat = new THREE.MeshStandardMaterial({ color: '#0f172a', metalness: 0.9, roughness: 0.2 });
  const flameMat = new THREE.MeshBasicMaterial({ color: '#38bdf8' });
  lib.disposables.push(packMat, thrusterMat, flameMat);

  // Khối thân balo phản lực
  const bodyGeo = new THREE.BoxGeometry(torsoW * 0.85, torsoH * 0.75, torsoD * 0.65);
  const body = new THREE.Mesh(bodyGeo, packMat);
  body.position.set(0, torsoH * 0.55, -torsoD * 0.72);
  accGroup.add(body);

  // 2 Ống xả phản lực
  [-1, 1].forEach((side) => {
    const nozGeo = new THREE.CylinderGeometry(0.06, 0.08, 0.22, 12);
    const noz = new THREE.Mesh(nozGeo, thrusterMat);
    noz.position.set(side * torsoW * 0.28, torsoH * 0.15, -torsoD * 0.72);
    accGroup.add(noz);

    // Ngọn lửa ion xanh
    const flGeo = new THREE.ConeGeometry(0.05, 0.16, 8);
    flGeo.rotateX(Math.PI);
    const fl = new THREE.Mesh(flGeo, flameMat);
    fl.position.set(side * torsoW * 0.28, torsoH * 0.15 - 0.15, -torsoD * 0.72);
    accGroup.add(fl);

    lib.disposables.push(nozGeo, flGeo);
  });

  lib.disposables.push(bodyGeo);
}

export const scifi_acc_builders = {
  steampunk_boiler: buildAcc_steampunk_boiler,
  acid_tanks: buildAcc_acid_tanks,
  tesla_coil: buildAcc_tesla_coil,
  chrono_gears: buildAcc_chrono_gears,
  accretion_ring: buildAcc_accretion_ring,
  radiation_core: buildAcc_radiation_core,
  jetpack: buildAcc_jetpack
};
